import {Component, DoCheck, Input, OnChanges, SimpleChanges} from "@angular/core";
import {MicroFormService} from "./micro-form.service";
import {microFormProvider, MicroFormModel} from "./micro-form.model";

@Component({
  selector: "micro-select",
  templateUrl: "./micro-select.template.pug",
  providers: [microFormProvider(MicroSelectComponent)],
  outputs: MicroFormModel.OUTPUTS,
  inputs: [...MicroFormModel.INPUTS, "blank", "blankText", "items"],
})
export class MicroSelectComponent extends MicroFormModel implements OnChanges, DoCheck {
  private lastItems: string;
  _items: [string, string][] = [];

  @Input()
  blank: boolean;

  @Input()
  blankText: string;

  @Input()
  items: {[key: string]: string};

  constructor(public microFormService: MicroFormService) {
    super(microFormService);
  }

  private didItemsChange(): boolean {
    try {
      return JSON.stringify(this.items) !== this.lastItems;
    } catch (e) {
      console.warn(e);
      return true;
    }
  }

  ngDoCheck(): void {
    if (this.didItemsChange()) this.calculateItems();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["blank"] || changes["blankText"]) this.calculateItems();
  }

  calculateItems() {
    this._items = Object.entries(this.items).map(([a, b]) => ([`${a}`, `${b}`] as [string, string]));
    if (this.blank) this._items.unshift(["", this.blankText || ""]);
  }
}
